module.exports = __webpack_public_path__ + "static/media/tig-logo.6c2de196.png";